import { Card, CardContent } from "@/components/ui/card";
import { useClub } from "@/pages/ClubLayout";

const PLACEHOLDERS = {
  players: { title: "Jugadores", desc: "Gestiona los jugadores registrados en tu club.", icon: "Users" },
  "tee-times": { title: "Tee Times", desc: "Genera y administra tee times para tus competencias.", icon: "Clock" },
  rankings: { title: "Rankings", desc: "Configura rankings con etapas, categorias y puntos.", icon: "Trophy" },
  competitions: { title: "Competencias", desc: "Crea y administra torneos y ligas.", icon: "Medal" },
  team: { title: "Usuarios del Club", desc: "Administra los usuarios que operan dentro de tu club.", icon: "UserCog" },
  settings: { title: "Configuracion", desc: "Ajusta la configuracion general de tu club.", icon: "Settings" },
};

export default function ClubPlaceholder({ section }) {
  const ctx = useClub();
  const info = PLACEHOLDERS[section] || { title: section, desc: "Modulo en desarrollo." };

  return (
    <div className="p-6 lg:p-8 max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-[#0F172A]" data-testid={`club-${section}-title`}>
          {info.title}
        </h1>
        <p className="text-sm text-[#64748B] mt-1">{ctx?.club?.name}</p>
      </div>
      <Card className="card-default">
        <CardContent className="py-16 text-center">
          <p className="text-[#64748B] font-medium mb-1">Modulo en desarrollo</p>
          <p className="text-sm text-[#94A3B8]">{info.desc}</p>
        </CardContent>
      </Card>
    </div>
  );
}
